import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '@paypalcorp/pp-react';

const OmniPrompt = (props) => {
  const {
    // eslint-disable-next-line no-unused-vars
    intentLabel, onClickHandler, totalIntentsLength, intentCardIcon,
  } = props;

  const intentCardClass = (length) => classNames({
    'ocp--one': length === 1,
    'ocp--two': length === 2,
    'ocp--three': length === 3,
  });
  const handleKeyPress = (event) => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      onClickHandler(event);
    }
  };
  return (
    <button className={intentCardClass(totalIntentsLength)} onClick={(e) => onClickHandler(e)} onKeyPress={(e) => handleKeyPress(e)} role="button" tabIndex={0}>
      <span className="icon-class"><Icon name={intentCardIcon} size="lg" as="i" /></span>
      <span className="ocp-label text-center">
        {intentLabel}
      </span>
    </button>

  );
};

OmniPrompt.propTypes = {
  intentLabel: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  totalIntentsLength: PropTypes.string.isRequired,
  intentCardIcon: PropTypes.string.isRequired,
};

export default OmniPrompt;
